import EventUpdateConfirmationModal from "./EventUpdateConfirmationModal";

export default EventUpdateConfirmationModal;
